export const getConflictProjectJobs = (sourceJobs, targetJobs) => {
    const STATUS_HIERARCHY = [
        'Pending Scheduling',
        'Client Reschedule',
        'Schedule',
        'Completed',
        'Paid',
    ]
    return sourceJobs
        .filter((sourceJob) => {
            const targetJob = targetJobs.find(
                (job) => job.project.id === sourceJob.project.id
            )

            if (!targetJob) return false

            const targetJobStatusRank = STATUS_HIERARCHY.indexOf(
                targetJob.overall_status
            )
            const sourceJobStatusRank = STATUS_HIERARCHY.indexOf(
                sourceJob.overall_status
            )

            return targetJobStatusRank === sourceJobStatusRank
        })
        .map((sourceJob) => {
            const targetJob = targetJobs.find(
                (job) => job.project.id === sourceJob.project.id
            )
            return {
                project: sourceJob.project,
                jobs: [targetJob, sourceJob],
            }
        })
}
